import React from 'react';
import { Link } from 'react-router-dom';

const Registration = () => {
    return (
        <div className="bg-gray-50 pt-24 pb-16 px-6 md:px-20">
            <div className="max-w-6xl mx-auto">
                {/* Header Section */}
                <div className="text-center mb-16">
                    <h1 className="text-5xl font-extrabold text-[#0c24da] mb-4">Company Registration</h1>
                    <h2 className="text-2xl font-semibold text-gray-700">Complete Company Registration & Incorporation Services</h2>
                    <p className="mt-4 text-gray-600 max-w-3xl mx-auto">
                        Starting a business begins with the right legal foundation. We provide end-to-end support to help you establish your company quickly, accurately, and efficiently.
                    </p>
                </div>

                {/* Registration Services Grid */}
                <div className="bg-white p-10 rounded-3xl shadow-lg mb-16 border-t-4 border-[#0c24da]">
                    <h3 className="text-3xl font-bold mb-8">Our Registration Services</h3>
                    <div className="grid md:grid-cols-3 gap-6">
                        {[
                            "Private Limited Company", "LLP Registration", "One Person Company (OPC)",
                            "Sole Proprietorship", "Partnership Firm", "Startup Registration",
                            "Business Name Reservation", "Digital Signature (DSC)", "DIN Assistance",
                            "MOA & AOA Preparation", "Legal Documentation", "Compliance Guidance"
                        ].map((service, i) => (
                            <div key={i} className="bg-gray-50 p-4 rounded-xl border border-gray-200 text-center font-medium text-gray-700">
                                {service}
                            </div>
                        ))}
                    </div>
                </div>

                {/* Why Choose Us */}
                <div className="bg-white p-10 rounded-3xl shadow-lg border-l-8 border-[#f15a24] mb-16">
                    <h3 className="text-3xl font-bold mb-6">Why Choose Rajkuruma?</h3>
                    <ul className="grid md:grid-cols-2 gap-4 text-gray-700">
                        {[
                            "Fast & Hassle-Free Registration Process",
                            "Experienced Business Consultants",
                            "Transparent Pricing (No Hidden Charges)",
                            "Accurate Legal Documentation",
                            "End-to-End Support",
                            "Ongoing Compliance Advisory"
                        ].map((item, i) => (
                            <li key={i} className="flex items-center font-medium">✅ {item}</li>
                        ))}
                    </ul>
                </div>

                {/* Final CTA */}
                <div className="text-center bg-[#1a2b4d] p-12 rounded-3xl text-white">
                    <h3 className="text-3xl font-bold mb-4">Ready to Incorporate?</h3>
                    <p className="mb-8">Launch your venture with confidence. Speak to our experts today.</p>
                    <Link to="/enquiry" className="bg-[#f15a24] hover:bg-[#d44d18] px-10 py-4 font-bold rounded-full text-lg transition">START REGISTRATION →</Link>
                </div>
            </div>
        </div>
    );
};

export default Registration;